import type { RuleStyle } from '@atlaskit/adf-schema/rule';

export const DEFAULT_DIVIDER_STYLE = 'solid';
export const DEFAULT_DIVIDER_WEIGHT = 2;

export type DividerStyle = RuleStyle;
export type DividerWeight = 1 | 2 | 3;
